// SAVDO KANALLARI (Q-046): kanal narxi — server (app.channel_markup, app.order_add_lines) bilan bir xil qoida.
// Kassa ko'rsatgan summa server hisoblagan summaga teng bo'lishi shart (aks holda PRICE_MISMATCH).

export interface ChannelPrice {
  product_id: string;
  /** Alohida narx; null — qoida bo'yicha */
  price: number | null;
  is_available: boolean;
}

export interface ChannelRule {
  id: string;
  name: string;
  kind: 'aggregator' | 'own';
  markup_pct: number;
  round_to: number;
  prices: ChannelPrice[];
}

/** Panelda: komissiya va holat ham */
export interface Channel extends ChannelRule {
  commission_pct: number;
  is_active: boolean;
  sort_order: number;
}

export const ROUND_OPTIONS = [
  { value: 0, label: 'Yaxlitlanmaydi' },
  { value: 100, label: '100 so‘mgacha' },
  { value: 500, label: '500 so‘mgacha' },
  { value: 1000, label: '1 000 so‘mgacha' },
] as const;

/**
 * +% va yaxlitlash (yuqoriga). Butun sonlar bilan hisoblanadi — kasr xatosi bo'lmasin
 * (35 000 × 1,15 JavaScript'da 40 249,999… chiqadi; Postgres'da aniq 40 250).
 */
export function channelMarkup(rule: Pick<ChannelRule, 'markup_pct' | 'round_to'> | null | undefined, price: number): number {
  if (!rule) return price;
  const m = Math.round(Number(rule.markup_pct) * 100); // foizning yuzdan biri
  const step = Number(rule.round_to) || 0;
  const n = price * (10000 + m); // narx × 10 000
  if (step <= 0) return Math.max(0, Math.round(n / 10000));
  const cents = Math.round(n / 100); // tiyin (so'mning yuzdan biri)
  return Math.max(0, Math.ceil(cents / (step * 100)) * step);
}

export function channelRow(rule: ChannelRule | null | undefined, productId: string): ChannelPrice | undefined {
  return rule?.prices.find((p) => p.product_id === productId);
}

/** Mahsulotning kanaldagi narxi: alohida narx yoki qoida */
export function channelUnit(rule: ChannelRule | null | undefined, productId: string, base: number): number {
  if (!rule) return base;
  const row = channelRow(rule, productId);
  return row?.price ?? channelMarkup(rule, base);
}

export function channelAvailable(rule: ChannelRule | null | undefined, productId: string): boolean {
  const row = channelRow(rule, productId);
  return !row || row.is_available;
}

/** Kanal narxidan komissiyadan keyin qoladigan pul */
export function afterCommission(price: number, commissionPct: number): number {
  return Math.round(price * (1 - commissionPct / 100));
}
